import { defineWebModule } from '@itc/sdk';

// Fleet in the shell (design §7.5, plan 6B): the deployments page, one deployment's page, its nav entry and its admin section. The pages
// are plain lists, sheets and selects that drive every call. One deployment's page is also drawn as FleetCom's org chart (plan 6C Chunk 3,
// read-only so far): `chart/FleetChart.vue`, loaded by a dynamic import from the page, so Vue Flow and the brand art are a chunk of their own.
export default defineWebModule({
  name: 'fleet',
  title: 'Fleet',
  routes: [
    { path: '/fleet', component: () => import('./pages/FleetPage.vue'), meta: { permission: 'fleet.view', title: 'Fleet' } },
    { path: '/fleet/:id', component: () => import('./pages/DeploymentPage.vue'), meta: { permission: 'fleet.view', title: 'Deployment' } },
  ],
  nav: [{ label: 'Fleet', to: '/fleet', permission: 'fleet.view', icon: 'fleet' }],
  admin: [{ label: 'Fleet', path: '/admin/fleet', component: () => import('./admin/AdminPage.vue'), permission: 'fleet.admin' }],
});
